import html2canvas from 'html2canvas-pro';
import jsPDF from 'jspdf';
import Papa from 'papaparse';

interface CalendarPost {
  date: string;
  time: string;
  platform: string;
  topic: string;
  text: string;
  imageUrls?: string[];
  videoUrl?: string;
  pageName?: string;
  username?: string;
}

export const KONTENTINO_LOGO_SVG = `<svg width="136" height="18" viewBox="0 0 136 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.3945 0.064209H22.982V8.87135H23.1588L30.4713 0.064209H33.6213L27.5463 7.23207L34.457 17.5339H31.3874L25.8588 9.33742H25.7624L22.982 12.5999V17.5178H20.3945V0.064209Z" fill="#2146EC"/>
<path d="M34.5857 11.3786C34.5857 7.52141 37.141 4.86963 40.741 4.86963C44.325 4.86963 46.8964 7.50534 46.8964 11.3786C46.8964 15.2839 44.3089 17.9036 40.741 17.9036C37.1571 17.9036 34.5857 15.2518 34.5857 11.3786ZM40.741 15.7018C42.8625 15.7018 44.3089 14.1911 44.3089 11.3786C44.3089 8.5982 42.8785 7.05534 40.741 7.05534C38.6196 7.05534 37.1732 8.61427 37.1732 11.3786C37.1732 14.1589 38.6196 15.7018 40.741 15.7018Z" fill="#2146EC"/>
<path d="M49.1143 5.23923H51.4285V6.97494H51.541C52.2803 5.72137 53.7268 4.85352 55.6232 4.85352C58.275 4.85352 59.7535 6.39637 59.7535 9.16066V17.5178H57.2946V9.96423C57.2946 8.0678 56.491 7.15173 54.8196 7.15173C52.7625 7.15173 51.5893 8.53387 51.5893 10.9446V17.5178H49.1143V5.23923Z" fill="#2146EC"/>
<path d="M63.2089 14.7375V7.425H61.3928V5.23929H63.1928V2.25H65.6518V5.23929H68.0785V7.425H65.6518V14.2393C65.6518 14.9143 65.925 15.2196 66.5357 15.2196H68.1107V17.5179H65.8125C64.0285 17.5179 63.2089 16.6339 63.2089 14.7375Z" fill="#2146EC"/>
<path d="M69.3804 11.4107C69.3804 7.44102 71.7429 4.85352 75.5036 4.85352C79.0072 4.85352 81.3054 7.11959 81.3054 11.041C81.3054 11.3946 81.2893 11.7482 81.2572 12.1499H71.9839C72.1768 14.416 73.5589 15.6857 75.5518 15.6857C77.3197 15.6857 78.4929 14.9303 78.7822 13.4357H81.3214C80.9036 16.3124 78.7339 17.8714 75.5518 17.8714C71.6625 17.9035 69.3804 15.3642 69.3804 11.4107ZM78.6214 10.2535C78.525 8.30887 77.3679 7.00709 75.5036 7.00709C73.5589 7.00709 72.2893 8.22852 72.0322 10.2535H78.6214Z" fill="#2146EC"/>
<path d="M83.5874 5.23923H85.9017V6.97494H86.0142C86.7535 5.72137 88.1999 4.85352 90.0963 4.85352C92.7481 4.85352 94.2267 6.39637 94.2267 9.16066V17.5178H91.7678V9.96423C91.7678 8.0678 90.9642 7.15173 89.2928 7.15173C87.2356 7.15173 86.0624 8.53387 86.0624 10.9446V17.5178H83.5874V5.23923Z" fill="#2146EC"/>
<path d="M97.6821 14.7375V7.425H95.8821V5.23929H97.6821V2.25H100.125V5.23929H102.552V7.425H100.125V14.2393C100.125 14.9143 100.398 15.2196 101.009 15.2196H102.584V17.5179H100.286C98.5017 17.5179 97.6821 16.6339 97.6821 14.7375Z" fill="#2146EC"/>
<path d="M104.721 0.466064H107.534V3.10178H104.721V0.466064ZM104.898 5.23928H107.373V17.5179H104.898V5.23928Z" fill="#2146EC"/>
<path d="M110.395 5.23923H112.709V6.97494H112.821C113.561 5.72137 115.007 4.85352 116.903 4.85352C119.555 4.85352 121.034 6.39637 121.034 9.16066V17.5178H118.575V9.96423C118.575 8.0678 117.771 7.15173 116.1 7.15173C114.043 7.15173 112.87 8.53387 112.87 10.9446V17.5178H110.395V5.23923Z" fill="#2146EC"/>
<path d="M123.043 11.3786C123.043 7.52141 125.598 4.86963 129.198 4.86963C132.782 4.86963 135.353 7.50534 135.353 11.3786C135.353 15.2839 132.766 17.9036 129.198 17.9036C125.598 17.9036 123.043 15.2518 123.043 11.3786ZM129.182 15.7018C131.303 15.7018 132.75 14.1911 132.75 11.3786C132.75 8.5982 131.32 7.05534 129.182 7.05534C127.061 7.05534 125.614 8.61427 125.614 11.3786C125.614 14.1589 127.077 15.7018 129.182 15.7018Z" fill="#2146EC"/>
<path d="M16.3124 5.23926L6.02671 12.15L0.064209 7.10354V10.2214L5.73742 14.9303H0.064209V17.5178H16.3124V14.9303H11.7964H11.7321H8.26064H6.78207H6.49278L16.3124 8.3089V5.23926Z" fill="#2146EC"/>
</svg>`;

const KONTENTINO_WATERMARK = 'Schedule posts across platforms at www.kontentino.com';

// PDF Footer Messages - Different for each page
const PDF_FOOTER_PAGE1 = 'Save 23 hours per month with automated scheduling at www.kontentino.com';
const PDF_FOOTER_POST_LIST = 'Stop chasing approvals via email. Real-time comments, notifications & version control at www.kontentino.com';

// Platform SVG Icons (16x16)
const PLATFORM_ICONS = {
  facebook: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="16" height="16" rx="4" fill="#1778F2"/><path d="M10.3249 8.625L10.6026 6.81523H8.86609V5.64082C8.86609 5.1457 9.10867 4.66309 9.88641 4.66309H10.6759V3.12227C10.6759 3.12227 9.95945 3 9.27449 3C7.84441 3 6.90965 3.8668 6.90965 5.43594V6.81523H5.32V8.625H6.90965V13H8.86609V8.625H10.3249Z" fill="white"/></svg>`,
  instagram: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="16" height="16" rx="4" fill="url(#paint0_linear_4428_1970)"/><g clip-path="url(#clip0_4428_1970)"><path d="M8.00342 5.75732C6.76123 5.75732 5.75928 6.75928 5.75928 8.00146C5.75928 9.24365 6.76123 10.2456 8.00342 10.2456C9.24561 10.2456 10.2476 9.24365 10.2476 8.00146C10.2476 6.75928 9.24561 5.75732 8.00342 5.75732ZM8.00342 9.46045C7.20068 9.46045 6.54443 8.80615 6.54443 8.00146C6.54443 7.19678 7.19873 6.54248 8.00342 6.54248C8.80811 6.54248 9.4624 7.19678 9.4624 8.00146C9.4624 8.80615 8.80615 9.46045 8.00342 9.46045ZM10.8628 5.66553C10.8628 5.95654 10.6284 6.18897 10.3394 6.18897C10.0483 6.18897 9.81592 5.95459 9.81592 5.66553C9.81592 5.37646 10.0503 5.14209 10.3394 5.14209C10.6284 5.14209 10.8628 5.37646 10.8628 5.66553ZM12.3491 6.19678C12.3159 5.49561 12.1558 4.87451 11.6421 4.36279C11.1304 3.85107 10.5093 3.69092 9.80811 3.65576C9.08545 3.61475 6.91943 3.61475 6.19678 3.65576C5.49756 3.68896 4.87646 3.84912 4.36279 4.36084C3.84912 4.87256 3.69092 5.49365 3.65576 6.19482C3.61475 6.91748 3.61475 9.0835 3.65576 9.80615C3.68896 10.5073 3.84912 11.1284 4.36279 11.6401C4.87646 12.1519 5.49561 12.312 6.19678 12.3472C6.91943 12.3882 9.08545 12.3882 9.80811 12.3472C10.5093 12.314 11.1304 12.1538 11.6421 11.6401C12.1538 11.1284 12.314 10.5073 12.3491 9.80615C12.3901 9.0835 12.3901 6.91943 12.3491 6.19678ZM11.4155 10.5815C11.2632 10.9644 10.9683 11.2593 10.5835 11.4136C10.0073 11.6421 8.64014 11.5894 8.00342 11.5894C7.3667 11.5894 5.99756 11.6401 5.42334 11.4136C5.04053 11.2612 4.74561 10.9663 4.59131 10.5815C4.36279 10.0054 4.41553 8.63818 4.41553 8.00146C4.41553 7.36475 4.36475 5.99561 4.59131 5.42139C4.74365 5.03857 5.03857 4.74365 5.42334 4.58936C5.99951 4.36084 7.3667 4.41357 8.00342 4.41357C8.64014 4.41357 10.0093 4.36279 10.5835 4.58936C10.9663 4.7417 11.2612 5.03662 11.4155 5.42139C11.644 5.99756 11.5913 7.36475 11.5913 8.00146C11.5913 8.63818 11.644 10.0073 11.4155 10.5815Z" fill="white"/></g><defs><linearGradient id="paint0_linear_4428_1970" x1="14.4" y1="1.6" x2="3.2" y2="16" gradientUnits="userSpaceOnUse"><stop stop-color="#DB01AD"/><stop offset="0.51331" stop-color="#FA0116"/><stop offset="1" stop-color="#FFC801"/></linearGradient><clipPath id="clip0_4428_1970"><rect width="10" height="10" fill="white" transform="translate(3 3)"/></clipPath></defs></svg>`,
  twitter: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="16" height="16" rx="4" fill="black"/><path d="M3.02438 3L6.88527 8.51559L3 13H3.87442L7.27596 9.07383L10.0243 13H13L8.92188 7.17417L12.5383 3H11.6638L8.53119 6.61592L6.00006 3H3.02438ZM4.31028 3.68817H5.67731L11.7139 12.3117H10.3469L4.31028 3.68817Z" fill="white"/></svg>`,
  linkedin: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="16" height="16" rx="4" fill="#0A66C2"/><path d="M5.33398 6.5H3.66732V12.3333H5.33398V6.5Z" fill="white"/><path d="M5.50065 4.83333C5.50065 5.29357 5.12755 5.66667 4.66732 5.66667C4.20708 5.66667 3.83398 5.29357 3.83398 4.83333C3.83398 4.3731 4.20708 4 4.66732 4C5.12755 4 5.50065 4.3731 5.50065 4.83333Z" fill="white"/><path d="M12.334 9.00667C12.334 7.18667 11.5407 6.33333 10.2673 6.33333C9.22732 6.33333 8.66732 6.94667 8.40065 7.38V6.5H6.73398C6.75398 6.93333 6.73398 12.3333 6.73398 12.3333H8.40065V9.08C8.40065 8.93333 8.41398 8.78667 8.45398 8.68667C8.56732 8.39333 8.83398 8.09333 9.28065 8.09333C9.86732 8.09333 10.1073 8.54 10.1073 9.18667V12.3333H11.774L11.774 9.00667H12.334Z" fill="white"/></svg>`,
  youtube: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="16" height="16" rx="4" fill="#FF0000"/><path d="M12.7334 5.46668C12.6268 5.08002 12.3201 4.77335 11.9334 4.66668C11.2268 4.46668 8.00008 4.46668 8.00008 4.46668C8.00008 4.46668 4.77341 4.46668 4.06675 4.66668C3.68008 4.77335 3.37341 5.08002 3.26675 5.46668C3.06675 6.17335 3.06675 7.64002 3.06675 7.64002C3.06675 7.64002 3.06675 9.10668 3.26675 9.81335C3.37341 10.2 3.68008 10.5067 4.06675 10.6133C4.77341 10.8133 8.00008 10.8133 8.00008 10.8133C8.00008 10.8133 11.2268 10.8133 11.9334 10.6133C12.3201 10.5067 12.6268 10.2 12.7334 9.81335C12.9334 9.10668 12.9334 7.64002 12.9334 7.64002C12.9334 7.64002 12.9334 6.17335 12.7334 5.46668ZM7.00008 9.10668V6.17335L9.60008 7.64002L7.00008 9.10668Z" fill="white"/></svg>`,
  pinterest: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="16" height="16" rx="4" fill="#E60023"/><path d="M8.00008 3C5.23858 3 3.00008 5.23842 3.00008 8C3.00008 9.92333 4.06508 11.6058 5.65508 12.5108C5.63175 12.1542 5.61675 11.6433 5.70175 11.2517L6.21008 9.02917C6.21008 9.02917 6.06758 8.74333 6.06758 8.31917C6.06758 7.66667 6.45508 7.17917 6.93508 7.17917C7.34008 7.17917 7.53675 7.48667 7.53675 7.8525C7.53675 8.2625 7.27175 8.88083 7.13508 9.45583C7.02008 9.94417 7.37508 10.3433 7.85758 10.3433C8.73175 10.3433 9.40925 9.4175 9.40925 8.09583C9.40925 6.9225 8.57008 6.11 7.98008 6.11C7.23508 6.11 6.79425 6.6675 6.79425 7.2575C6.79425 7.67583 6.95925 8.12167 7.16425 8.35917C7.20675 8.40917 7.21258 8.45333 7.20092 8.50417L7.08758 8.9975C7.06508 9.095 7.01508 9.115 6.91258 9.07167C6.28425 8.77917 5.88925 8.00917 5.88925 7.24167C5.88925 5.86083 6.91258 4.5775 8.09175 4.5775C9.04258 4.5775 9.78425 5.29333 9.78425 8.07833C9.78425 9.4975 8.97925 10.6225 7.83008 10.6225C7.34258 10.6225 6.88425 10.3658 6.72675 10.0633L6.45925 11.1525C6.34175 11.5967 5.99758 12.1658 5.76758 12.5108C6.16675 12.6367 6.58675 12.7042 7.02175 12.7042C9.78341 12.7042 12.0217 10.4658 12.0217 7.70417C12.0217 4.94167 9.76175 3 8.00008 3Z" fill="white"/></svg>`,
  google_my_business: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="16" height="16" rx="4" fill="#4285F4"/><path d="M12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8Z" fill="white"/><path d="M8 5C9.65685 5 11 6.34315 11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5Z" fill="#4285F4"/></svg>`,
  threads: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="16" height="16" rx="4" fill="black"/><path d="M8.99334 5.90734C8.46001 5.62067 7.82001 5.488 7.10001 5.51467C5.67334 5.56734 4.48667 6.348 4.31334 7.88067H5.53334C5.66001 7.18067 6.29334 6.60734 7.12667 6.57467C7.96001 6.54134 8.66001 7.02067 8.98001 7.628C9.00001 7.668 9.02001 7.71467 9.03334 7.76067C8.22667 7.74734 7.47334 7.82067 6.80667 8.00734C5.49334 8.37467 4.66667 9.20734 4.71334 10.32C4.76001 11.4073 5.66667 12.2273 6.93334 12.2533C8.07334 12.2787 8.93334 11.7927 9.42001 11.0207C9.68001 10.6007 9.86001 10.0607 9.95334 9.46734C10.2267 9.57467 10.4667 9.708 10.6733 9.86734C11.4667 10.4733 11.6733 11.3467 11.4467 12.06C11.2333 12.7267 10.5733 13.3 9.76001 13.3727C8.91334 13.4473 8.29334 13.1733 7.92001 12.8207L7.10001 13.8467C7.72001 14.3333 8.61334 14.6327 9.67334 14.54C11.0733 14.4193 12.1533 13.468 12.46 12.3267C12.7867 11.1133 12.36 9.71467 11.2267 8.81467C10.9 8.56067 10.5333 8.36067 10.1333 8.21467C10.1333 7.29467 9.78001 6.40067 8.99334 5.90734ZM8.82667 9.37467C8.76667 9.79467 8.64667 10.1273 8.48001 10.38C8.10001 10.9467 7.52001 11.234 6.86667 11.214C6.34667 11.1987 5.90667 10.9153 5.88001 10.3C5.85334 9.69467 6.28001 9.17467 7.14667 8.93467C7.60001 8.80067 8.17334 8.74067 8.82667 8.74734V9.37467Z" fill="white"/></svg>`,
  tiktok: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="16" height="16" rx="4" fill="black"/><path d="M12.0267 6.74667C11.3267 6.74667 10.68 6.52667 10.1467 6.15333V10.5333C10.1467 12.24 8.76 13.6267 7.05333 13.6267C5.34667 13.6267 3.96 12.24 3.96 10.5333C3.96 8.82667 5.34667 7.44 7.05333 7.44C7.12 7.44 7.18667 7.44667 7.25333 7.44667V8.8C7.18667 8.79333 7.12 8.78667 7.05333 8.78667C6.09333 8.78667 5.30667 9.57333 5.30667 10.5333C5.30667 11.4933 6.09333 12.28 7.05333 12.28C8.01333 12.28 8.84667 11.52 8.84667 10.56L8.86667 2.37333H10.1733C10.3067 3.56667 11.0733 4.56 12.0267 4.92V6.74667Z" fill="white"/></svg>`,
} as const;

// Helper function to convert SVG to data URL for PDF embedding
async function getPlatformIconDataUrl(platform: string): Promise<string> {
  const svgMap: Record<string, string> = {
    facebook: PLATFORM_ICONS.facebook,
    instagram: PLATFORM_ICONS.instagram,
    twitter: PLATFORM_ICONS.twitter,
    linkedin: PLATFORM_ICONS.linkedin,
    youtube: PLATFORM_ICONS.youtube,
    pinterest: PLATFORM_ICONS.pinterest,
    google_my_business: PLATFORM_ICONS.google_my_business,
    threads: PLATFORM_ICONS.threads,
    tiktok: PLATFORM_ICONS.tiktok,
  };

  const svg = svgMap[platform] || PLATFORM_ICONS.facebook;
  const blob = new Blob([svg], { type: 'image/svg+xml' });
  const url = URL.createObjectURL(blob);

  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = 16;
      canvas.height = 16;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Failed to get canvas context'));
        return;
      }
      ctx.drawImage(img, 0, 0);
      const dataUrl = canvas.toDataURL('image/png');
      URL.revokeObjectURL(url);
      resolve(dataUrl);
    };
    img.onerror = reject;
    img.src = url;
  });
}

// Helper function to load image from URL and convert to data URL for PDF embedding
// Creates a 1:1 square crop (object-fit: cover behavior)
async function loadImageAsDataUrl(imageUrl: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous'; // Handle CORS

    img.onload = () => {
      const imgWidth = img.naturalWidth;
      const imgHeight = img.naturalHeight;

      // Create 1:1 square canvas
      const size = Math.min(imgWidth, imgHeight);
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;

      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Failed to get canvas context'));
        return;
      }

      // Calculate center crop coordinates (object-fit: cover)
      const offsetX = (imgWidth - size) / 2;
      const offsetY = (imgHeight - size) / 2;

      // Draw center-cropped square
      ctx.drawImage(img, offsetX, offsetY, size, size, 0, 0, size, size);
      const dataUrl = canvas.toDataURL('image/jpeg', 0.85); // Use JPEG with 85% quality for smaller size
      resolve(dataUrl);
    };

    img.onerror = () => {
      reject(new Error(`Failed to load image: ${imageUrl}`));
    };

    img.src = imageUrl;
  });
}

// Emoji handling utilities for PDF generation
const processEmoji = {
  // Regex for matching emojis and common symbols
  // Includes:
  // - Basic symbols (⚠️, ℹ️, etc): \u2000-\u2BFF
  // - Emojis: \u{1F300}-\u{1F9FF}
  // - Variation Selectors (for emoji styling): \uFE00-\uFE0F
  // - Zero Width Joiner (for compound emojis): \u200D
  regex: /[\u2000-\u2BFF][\uFE00-\uFE0F]?|[\u{1F300}-\u{1F9FF}][\uFE00-\uFE0F]?|[\u{1F300}-\u{1F9FF}]\u200D[\u{1F300}-\u{1F9FF}][\uFE00-\uFE0F]?/gu,

  // Create a canvas with emoji
  createCanvas(emoji: string, parentElement: HTMLElement) {
    const computedStyle = window.getComputedStyle(parentElement);
    const fontSize = parseInt(computedStyle.fontSize);
    const emojiSize = Math.round(fontSize * 1.2); // 20% larger than text
    const size = emojiSize * 2; // Double size for better quality

    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    if (!ctx) return { canvas, emojiSize };

    ctx.font = `${size}px Arial`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(emoji, size/2, size/2);

    return { canvas, emojiSize };
  },

  // Create an image element from canvas
  createImageElement(canvas: HTMLCanvasElement, emojiSize: number) {
    const img = document.createElement('img');
    img.src = canvas.toDataURL('image/png');
    img.style.width = `${emojiSize}px`;
    img.style.height = `${emojiSize}px`;
    img.style.verticalAlign = 'middle';
    img.style.display = 'inline-block';
    img.style.margin = '0 1px';
    return img;
  },

  // Process a text node and replace emojis with images
  processTextNode(node: Node) {
    if (!node.parentElement) return;

    const text = node.textContent || '';
    const matches = text.match(processEmoji.regex);

    if (!matches) return;

    // Create document fragment for new content
    const fragment = document.createDocumentFragment();
    let lastIndex = 0;

    matches.forEach((emoji) => {
      // Add text before emoji
      const textBefore = text.slice(lastIndex, text.indexOf(emoji, lastIndex));
      if (textBefore) {
        fragment.appendChild(document.createTextNode(textBefore));
      }

      // Add emoji image
      const { canvas, emojiSize } = processEmoji.createCanvas(emoji, node.parentElement!);
      const img = processEmoji.createImageElement(canvas, emojiSize);
      fragment.appendChild(img);

      lastIndex = text.indexOf(emoji, lastIndex) + emoji.length;
    });

    // Add remaining text
    if (lastIndex < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    }

    node.parentNode!.replaceChild(fragment, node);
  }
};

export interface ExportImageData {
  blob: Blob;
  dataUrl: string;
  filename: string;
}

export async function exportAsImage(
  calendarElement: HTMLElement,
  month: string,
  _viewMode: 'calendar' | 'list' | 'calendar+list' | 'table' = 'calendar'
): Promise<ExportImageData> {
  // Clone the element to avoid modifying the original
  let clonedElement = calendarElement.cloneNode(true) as HTMLElement;

  // Select the correct tab content based on viewMode
  const tabContent = clonedElement.querySelector(`[data-state="active"]`) as HTMLElement;
  if (tabContent) {
    // If we found an active tab, use that as the element to export
    clonedElement = tabContent;
  }

  // Process all emojis in the cloned element
  clonedElement.querySelectorAll('*').forEach(el => {
    if (el.childNodes?.length) {
      Array.from(el.childNodes)
        .filter(node => node.nodeType === 3) // Text nodes only
        .forEach(node => processEmoji.processTextNode(node));
    }
  });

  // Temporarily add to document for proper rendering
  clonedElement.style.position = 'absolute';
  clonedElement.style.left = '-9999px';
  clonedElement.style.top = '-9999px';
  document.body.appendChild(clonedElement);

  const canvas = await html2canvas(clonedElement, {
    backgroundColor: '#ffffff',
    scale: 2,
    logging: false,
    useCORS: true,
  });

  // Remove from document
  document.body.removeChild(clonedElement);

  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Failed to get canvas context');

  const watermarkHeight = 50;
  const finalCanvas = document.createElement('canvas');
  finalCanvas.width = canvas.width;
  finalCanvas.height = canvas.height + watermarkHeight;
  const finalCtx = finalCanvas.getContext('2d');

  if (!finalCtx) throw new Error('Failed to get final canvas context');

  finalCtx.fillStyle = '#ffffff';
  finalCtx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);

  finalCtx.drawImage(canvas, 0, 0);

  // Create SVG image for logo
  const logoImg = new Image();
  const svgBlob = new Blob([KONTENTINO_LOGO_SVG], { type: 'image/svg+xml' });
  const url = URL.createObjectURL(svgBlob);

  await new Promise((resolve) => {
    logoImg.onload = resolve;
    logoImg.src = url;
  });

  // Draw logo (centered, scaled)
  const logoScale = 1.5;
  const logoWidth = 136 * logoScale;
  const logoHeight = 18 * logoScale;
  const logoX = 30;
  const logoY = canvas.height + (watermarkHeight - logoHeight) / 2;
  finalCtx.drawImage(logoImg, logoX, logoY, logoWidth, logoHeight);

  // Draw text next to logo
  finalCtx.fillStyle = '#666666';
  finalCtx.font = '20px system-ui, -apple-system, sans-serif';
  finalCtx.textAlign = 'left';
  finalCtx.textBaseline = 'middle';
  finalCtx.fillText(
    ' | ' + KONTENTINO_WATERMARK,
    logoX + logoWidth,
    logoY + logoHeight / 2
  );

  URL.revokeObjectURL(url);

  const dataUrl = finalCanvas.toDataURL('image/png');
  const filename = `content-calendar-${month}.png`;

  // Convert dataURL to blob
  const response = await fetch(dataUrl);
  const blob = await response.blob();

  return {
    blob,
    dataUrl,
    filename
  };
}

// Helper function to add footer to PDF page
function addPDFFooter(pdf: jsPDF, footerText: string, pageWidth: number, pageHeight: number, margin: number) {
  const yPosition = pageHeight - 15;
  pdf.setFontSize(10);
  pdf.setFont('helvetica', 'normal');
  pdf.setTextColor(33, 70, 236); // Brand blue color
  const footerLines = pdf.splitTextToSize(footerText, pageWidth - 2 * margin);
  pdf.text(footerLines, margin, yPosition);
}

// Helper function to add logo to PDF page
function addPDFLogo(pdf: jsPDF, margin: number) {
  // Add logo text representation (simpler for PDF)
  pdf.setFontSize(10);
  pdf.setFont('helvetica', 'bold');
  pdf.setTextColor(33, 70, 236); // Brand color
  pdf.text('Kontentino', margin, margin);
}

export interface ExportPDFData {
  blob: Blob;
  dataUrl: string;
  filename: string;
}

// Helper interface for month summary data
interface MonthSummary {
  monthStr: string;
  monthName: string;
  posts: CalendarPost[];
  dateRange: string;
  topics: string[];
  platformBreakdown: string;
  totalPosts: number;
}

// Helper function to group posts by month and generate summaries
function generateMonthSummaries(posts: CalendarPost[]): MonthSummary[] {
  // Group posts by month
  const postsByMonth = new Map<string, CalendarPost[]>();

  posts.forEach(post => {
    const monthStr = post.date.substring(0, 7); // YYYY-MM
    if (!postsByMonth.has(monthStr)) {
      postsByMonth.set(monthStr, []);
    }
    postsByMonth.get(monthStr)!.push(post);
  });

  // Generate summaries for each month
  const summaries: MonthSummary[] = [];

  Array.from(postsByMonth.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .forEach(([monthStr, monthPosts]) => {
      // Sort posts by date/time
      const sortedPosts = [...monthPosts].sort((a, b) => {
        const dateA = new Date(`${a.date}T${a.time}`);
        const dateB = new Date(`${b.date}T${b.time}`);
        return dateA.getTime() - dateB.getTime();
      });

      // Calculate date range
      const firstPost = sortedPosts[0];
      const lastPost = sortedPosts[sortedPosts.length - 1];
      const firstDate = new Date(firstPost.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      const lastDate = new Date(lastPost.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      const dateRange = firstDate === lastDate ? firstDate : `${firstDate} - ${lastDate}`;

      // Extract unique topics
      const topics = [...new Set(sortedPosts.map(p => p.topic))];

      // Calculate platform breakdown
      const platformCounts = new Map<string, number>();
      sortedPosts.forEach(post => {
        platformCounts.set(post.platform, (platformCounts.get(post.platform) || 0) + 1);
      });
      const platformBreakdown = Array.from(platformCounts.entries())
        .map(([platform, count]) => `${count} ${platform.charAt(0).toUpperCase() + platform.slice(1).replace(/_/g, ' ')}`)
        .join(' • ');

      // Format month name
      const [year, month] = monthStr.split('-').map(Number);
      const monthName = new Date(year, month - 1, 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

      summaries.push({
        monthStr,
        monthName,
        posts: sortedPosts,
        dateRange,
        topics,
        platformBreakdown,
        totalPosts: sortedPosts.length
      });
    });

  return summaries;
}

export async function exportAsPDF(
  calendarElement: HTMLElement,
  posts: CalendarPost[],
  month: string,
  monthSections?: HTMLElement[],
  _viewMode: 'calendar' | 'list' | 'calendar+list' | 'table' = 'calendar'
): Promise<ExportPDFData> {
  const pdf = new jsPDF('p', 'mm', 'a4');

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 15;

  // Select the active tab content for export based on viewMode
  // The active tab will have data-state="active" attribute from Radix UI Tabs
  let exportElement = calendarElement;
  const activeTabContent = calendarElement.querySelector(`[data-state="active"]`) as HTMLElement;
  if (activeTabContent) {
    exportElement = activeTabContent;
  }

  // PAGE 1: Calendar View(s)
  if (monthSections && monthSections.length > 1) {
    // Multi-month: capture each month separately
    for (let i = 0; i < monthSections.length; i++) {
      const monthSection = monthSections[i];
      const monthStr = monthSection.getAttribute('data-month') || '';

      // Clone the element to avoid modifying the original
      const clonedSection = monthSection.cloneNode(true) as HTMLElement;

      // Process all emojis in the cloned element
      clonedSection.querySelectorAll('*').forEach(el => {
        if (el.childNodes?.length) {
          Array.from(el.childNodes)
            .filter(node => node.nodeType === 3) // Text nodes only
            .forEach(node => processEmoji.processTextNode(node));
        }
      });

      // Temporarily add to document for proper rendering
      clonedSection.style.position = 'absolute';
      clonedSection.style.left = '-9999px';
      clonedSection.style.top = '-9999px';
      document.body.appendChild(clonedSection);

      const canvas = await html2canvas(clonedSection, {
        backgroundColor: '#ffffff',
        scale: 2,
        logging: false,
        useCORS: true,
        onclone: () => {
          // Fix image compression
          // @see https://github.com/parallax/jsPDF/issues/3178#issuecomment-1384411475
          const targetRect = clonedSection.getBoundingClientRect();
          clonedSection.querySelectorAll('img').forEach((img) => {
            const rect = img.getBoundingClientRect();
            try {
              // Only try to add image if it's a data URL (not external URL)
              // External URLs can cause CORS and encoding issues
              if (img.src && img.src.startsWith('data:')) {
                pdf.addImage(img, 'JPEG', targetRect.x - rect.x, targetRect.y - rect.y, rect.width, rect.height);
              }
            } catch (e) {
              console.error(`PDF image error: ${e}`);
            }
            img.remove();
          });
        }
      });

      // Remove from document
      document.body.removeChild(clonedSection);

      const imgData = canvas.toDataURL('image/png');
      const imgWidth = pageWidth - 2 * margin;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Add page for each month (except first which already exists)
      if (i > 0) {
        pdf.addPage();
      }

      // Add logo
      addPDFLogo(pdf, margin);

      // Add title with brand color
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(33, 70, 236); // Brand color
      pdf.text(`Content Calendar - ${monthStr}`, margin, margin + 10);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(100, 100, 100);
      const monthPosts = posts.filter(p => p.date.startsWith(monthStr));
      pdf.text(`${monthPosts.length} posts scheduled`, margin, margin + 17);

      // Calculate available height for image
      const availableHeight = pageHeight - margin * 2 - 30;
      const finalImgHeight = Math.min(imgHeight, availableHeight);

      pdf.addImage(imgData, 'PNG', margin, margin + 23, imgWidth, finalImgHeight);

      // Month comments section (moved from Page 2+)
      const yAfterImage = margin + 23 + finalImgHeight + 10;
      if (yAfterImage + 45 < pageHeight - 25) {
        // Month summary info
        const platformCounts = new Map<string, number>();
        monthPosts.forEach(p => {
          platformCounts.set(p.platform, (platformCounts.get(p.platform) || 0) + 1);
        });
        const platforms = Array.from(platformCounts.keys()).map(p =>
          p.charAt(0).toUpperCase() + p.slice(1).replace(/_/g, ' ')
        ).join(', ');
        const topics = [...new Set(monthPosts.map(p => p.topic))].join(', ');

        pdf.setFontSize(8);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(100, 100, 100);
        pdf.text(`Platforms: ${platforms}`, margin, yAfterImage);
        pdf.text(`Topics: ${topics}`, margin, yAfterImage + 4);

        // Overall month comments label
        pdf.setFontSize(9);
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(60, 60, 60);
        pdf.text('Overall Month Comments:', margin, yAfterImage + 10);

        // Month comments field
        const monthCommentsHeight = 25;
        const yCommentField = yAfterImage + 15;
        pdf.setFillColor(240, 245, 255);
        pdf.roundedRect(margin, yCommentField, pageWidth - 2 * margin, monthCommentsHeight, 3, 3, 'F');
        pdf.setDrawColor(33, 70, 236);
        pdf.setLineWidth(0.3);
        pdf.roundedRect(margin, yCommentField, pageWidth - 2 * margin, monthCommentsHeight, 3, 3);

        const monthCommentField = new (pdf as any).AcroFormTextField();
        monthCommentField.fieldName = `month_comment_${monthStr}`;
        monthCommentField.Rect = [margin + 2, yCommentField + 2, pageWidth - 2 * margin - 4, monthCommentsHeight - 4];
        monthCommentField.fontSize = 9;
        monthCommentField.maxFontSize = 9;
        monthCommentField.multiline = true;
        pdf.addField(monthCommentField);
      }

      // Add footer
      addPDFFooter(pdf, PDF_FOOTER_PAGE1, pageWidth, pageHeight, margin);
    }
  } else {
    // Single month: capture entire calendar (or active tab content)
    // Clone the element to avoid modifying the original
    const clonedElement = exportElement.cloneNode(true) as HTMLElement;

    // Process all emojis in the cloned element
    clonedElement.querySelectorAll('*').forEach(el => {
      if (el.childNodes?.length) {
        Array.from(el.childNodes)
          .filter(node => node.nodeType === 3) // Text nodes only
          .forEach(node => processEmoji.processTextNode(node));
      }
    });

    // Temporarily add to document for proper rendering
    clonedElement.style.position = 'absolute';
    clonedElement.style.left = '-9999px';
    clonedElement.style.top = '-9999px';
    document.body.appendChild(clonedElement);

    const canvas = await html2canvas(clonedElement, {
      backgroundColor: '#ffffff',
      scale: 2,
      logging: false,
      useCORS: true,
      onclone: () => {
        // Fix image compression
        // @see https://github.com/parallax/jsPDF/issues/3178#issuecomment-1384411475
        const targetRect = clonedElement.getBoundingClientRect();
        clonedElement.querySelectorAll('img').forEach((img) => {
          const rect = img.getBoundingClientRect();
          try {
            pdf.addImage(img, 'JPEG', targetRect.x - rect.x, targetRect.y - rect.y, rect.width, rect.height);
          } catch (e) {
            console.error(`PDF image error: ${e}`);
          }
          img.remove();
        });
      }
    });

    // Remove from document
    document.body.removeChild(clonedElement);

    const imgData = canvas.toDataURL('image/png');
    const imgWidth = pageWidth - 2 * margin;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    // Add logo
    addPDFLogo(pdf, margin);

    // Add title with brand color
    pdf.setFontSize(18);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor(33, 70, 236); // Brand color
    pdf.text(`Content Calendar - ${month}`, margin, margin + 10);

    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');
    pdf.setTextColor(100, 100, 100);
    pdf.text(`${posts.length} posts scheduled`, margin, margin + 17);

    const finalImgHeight = Math.min(imgHeight, pageHeight - margin * 3 - 30);
    pdf.addImage(imgData, 'PNG', margin, margin + 23, imgWidth, finalImgHeight);

    // Month comments section (moved from Page 2+)
    const yAfterImage = margin + 23 + finalImgHeight + 10;
    if (yAfterImage + 45 < pageHeight - 25) {
      // Month summary info
      const platformCounts = new Map<string, number>();
      posts.forEach(p => {
        platformCounts.set(p.platform, (platformCounts.get(p.platform) || 0) + 1);
      });
      const platforms = Array.from(platformCounts.keys()).map(p =>
        p.charAt(0).toUpperCase() + p.slice(1).replace(/_/g, ' ')
      ).join(', ');
      const topics = [...new Set(posts.map(p => p.topic))].join(', ');

      pdf.setFontSize(8);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(100, 100, 100);
      pdf.text(`Platforms: ${platforms}`, margin, yAfterImage);
      pdf.text(`Topics: ${topics}`, margin, yAfterImage + 4);

      // Overall month comments label
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(60, 60, 60);
      pdf.text('Overall Month Comments:', margin, yAfterImage + 10);

      // Month comments field
      const monthCommentsHeight = 25;
      const yCommentField = yAfterImage + 15;
      pdf.setFillColor(240, 245, 255);
      pdf.roundedRect(margin, yCommentField, pageWidth - 2 * margin, monthCommentsHeight, 2, 2, 'F');
      pdf.setDrawColor(33, 70, 236);
      pdf.setLineWidth(0.3);
      pdf.roundedRect(margin, yCommentField, pageWidth - 2 * margin, monthCommentsHeight, 2, 2);

      const monthCommentField = new (pdf as any).AcroFormTextField();
      monthCommentField.fieldName = `month_comment_${month}`;
      monthCommentField.Rect = [margin + 2, yCommentField + 2, pageWidth - 2 * margin - 4, monthCommentsHeight - 4];
      monthCommentField.fontSize = 9;
      monthCommentField.maxFontSize = 9;
      monthCommentField.multiline = true;
      pdf.addField(monthCommentField);
    }

    // Add Page 1 footer
    addPDFFooter(pdf, PDF_FOOTER_PAGE1, pageWidth, pageHeight, margin);
  }

  // PAGES 2+: Combined Post List + Approval by Month
  const monthSummaries = generateMonthSummaries(posts);
  let globalPostIndex = 0;

  for (const monthSummary of monthSummaries) {
    pdf.addPage();

    // Add logo
    addPDFLogo(pdf, margin);

    let yPosition = margin + 10;

    // Month Header with Summary
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor(33, 70, 236);
    pdf.text(monthSummary.monthName, margin, yPosition);
    yPosition += 8;

    // Summary box background (light gray)
    const summaryBoxHeight = 25;
    pdf.setFillColor(245, 245, 245);
    pdf.rect(margin, yPosition, pageWidth - 2 * margin, summaryBoxHeight, 'F');

    yPosition += 5;

    // Date range
    pdf.setFontSize(9);
    pdf.setFont('helvetica', 'normal');
    pdf.setTextColor(60, 60, 60);
    pdf.text(`Date range: ${monthSummary.dateRange}`, margin + 3, yPosition);
    yPosition += 5;

    // Total posts
    pdf.text(`${monthSummary.totalPosts} post${monthSummary.totalPosts > 1 ? 's' : ''} scheduled`, margin + 3, yPosition);
    yPosition += 5;

    // Platform breakdown
    const platformLines = pdf.splitTextToSize(`Platforms: ${monthSummary.platformBreakdown}`, pageWidth - 2 * margin - 6);
    pdf.text(platformLines, margin + 3, yPosition);
    yPosition += platformLines.length * 5;

    // Topics (if they fit)
    const topicsText = `Topics: ${monthSummary.topics.join(', ')}`;
    const topicLines = pdf.splitTextToSize(topicsText, pageWidth - 2 * margin - 6);
    if (yPosition + topicLines.length * 5 < yPosition + summaryBoxHeight - 3) {
      pdf.text(topicLines, margin + 3, yPosition);
    }

    yPosition = yPosition + summaryBoxHeight - 5 + 12; // Move past summary box + spacing

    // Post entries with inline approval (2-column layout)
    const lineHeight = 6; // Increased from 5 for better readability
    const postSpacing = 15; // Increased from 10 for better separation
    const leftColumnWidth = 120; // 2/3 of usable width
    const rightColumnWidth = 60; // 1/3 of usable width
    const cardPadding = 5; // Padding inside post cards

    // Pre-load all unique platform icons
    const uniquePlatforms = [...new Set(monthSummary.posts.map(p => p.platform))];
    const platformIconCache = new Map<string, string>();
    await Promise.all(
      uniquePlatforms.map(async (platform) => {
        try {
          const iconUrl = await getPlatformIconDataUrl(platform);
          platformIconCache.set(platform, iconUrl);
        } catch (err) {
          console.error(`Failed to load icon for ${platform}:`, err);
        }
      })
    );

    // Pre-load first image from each post
    const postImageCache = new Map<number, string>();
    await Promise.all(
      monthSummary.posts.map(async (post, index) => {
        if (post.imageUrls && post.imageUrls.length > 0) {
          try {
            const dataUrl = await loadImageAsDataUrl(post.imageUrls[0]);
            postImageCache.set(index, dataUrl);
          } catch (err) {
            console.error(`Failed to load image for post ${index}:`, err);
          }
        }
      })
    );

    monthSummary.posts.forEach((post, postIndex) => {
      // Calculate space needed for LEFT COLUMN (post content)
      const textLines = post.text ? pdf.splitTextToSize(post.text, leftColumnWidth - 2 * cardPadding) : [];
      const hasImageInCache = postImageCache.has(postIndex);
      const imageThumbnailSize = 45; // 1:1 square size in mm
      const imageSize = hasImageInCache ? Math.min(imageThumbnailSize, leftColumnWidth - 2 * cardPadding) : 0;

      const leftColumnHeight =
        cardPadding + // top padding
        lineHeight + // topic
        lineHeight + // date/time
        lineHeight + // platform
        (hasImageInCache ? lineHeight + imageSize + 2 : 0) + // image label + thumbnail + spacing
        (textLines.length > 0 ? lineHeight + textLines.length * lineHeight : 0) + // text
        (!hasImageInCache && post.imageUrls && post.imageUrls.length > 0 ? lineHeight : 0) + // media indicator fallback
        (post.videoUrl ? lineHeight : 0) + // video
        cardPadding; // bottom padding

      // Calculate space needed for RIGHT COLUMN (comments + approval)
      const commentFieldHeight = 15;
      const checkboxAreaHeight = 8;
      const rightColumnHeight =
        cardPadding + // top padding
        3 + // "Comments:" label
        commentFieldHeight +
        3 + // spacing
        checkboxAreaHeight +
        cardPadding; // bottom padding

      // Card height is the maximum of both columns
      const cardHeight = Math.max(leftColumnHeight, rightColumnHeight);

      // Check if we need a new page
      if (yPosition + cardHeight + postSpacing > pageHeight - 25) {
        addPDFFooter(pdf, PDF_FOOTER_POST_LIST, pageWidth, pageHeight, margin);
        pdf.addPage();
        addPDFLogo(pdf, margin);
        yPosition = margin + 10;
      }

      const cardTop = yPosition;

      // Draw card background (lighter gray)
      pdf.setFillColor(250, 250, 250);
      pdf.roundedRect(margin, cardTop, pageWidth - 2 * margin, cardHeight, 5, 5, 'F');

      // Draw card border (light gray)
      pdf.setDrawColor(210, 210, 210);
      pdf.setLineWidth(0.5);
      pdf.roundedRect(margin, cardTop, pageWidth - 2 * margin, cardHeight, 5, 5, 'S');

      // Draw vertical divider between columns
      pdf.setDrawColor(210, 210, 210);
      pdf.setLineWidth(0.3);
      pdf.line(margin + leftColumnWidth, cardTop, margin + leftColumnWidth, cardTop + cardHeight);

      // LEFT COLUMN: Post Content
      let leftY = cardTop + cardPadding;

      // Topic (bold, larger)
      pdf.setFontSize(11);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(0, 0, 0);
      pdf.text(post.topic, margin + cardPadding, leftY + 4);
      leftY += lineHeight;

      // Date/time (small, gray)
      pdf.setFontSize(8);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(120, 120, 120);
      pdf.text(`${post.date} at ${post.time}`, margin + cardPadding, leftY + 3);
      leftY += lineHeight;

      // Platform icon
      const platformIconUrl = platformIconCache.get(post.platform);
      if (platformIconUrl) {
        pdf.addImage(platformIconUrl, 'PNG', margin + cardPadding, leftY, 4, 4);
      }
      leftY += lineHeight;

      // Image thumbnail (if available)
      if (hasImageInCache && post.imageUrls && post.imageUrls.length > 0) {
        // Image label
        pdf.setFontSize(8);
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(80, 80, 80);
        const imageLabel = post.imageUrls.length > 1
          ? `${post.imageUrls.length} images:`
          : 'Image:';
        pdf.text(imageLabel, margin + cardPadding, leftY + 3);
        leftY += lineHeight;

        // Get cached image
        const imageDataUrl = postImageCache.get(postIndex);
        if (imageDataUrl) {
          // Use 1:1 square aspect ratio (object-fit: cover)
          const size = imageSize;

          // Ensure dimensions are valid numbers
          if (isNaN(size) || size <= 0) {
            console.error(`Invalid thumbnail size for post ${postIndex}`);
          } else {
            try {
              // Draw rounded background for image
              pdf.setFillColor(245, 245, 245);
              pdf.roundedRect(margin + cardPadding, leftY, size, size, 2, 2, 'F');

              // Add image (1:1 square, center-cropped)
              pdf.addImage(
                imageDataUrl,
                'JPEG',
                margin + cardPadding,
                leftY,
                size,
                size
              );

              leftY += size + 2; // Add spacing after image
            } catch (err) {
              console.error(`Failed to add image to PDF for post ${postIndex}:`, err);
            }
          }
        }
      }

      // Post text (improved font rendering)
      if (post.text) {
        leftY += 2; // Small gap before text
        pdf.setFontSize(9);
        pdf.setFont('helvetica', 'normal'); // Using standard helvetica for better rendering
        pdf.setTextColor(40, 40, 40);
        pdf.text(textLines, margin + cardPadding, leftY);
        leftY += textLines.length * lineHeight;
      }

      // Media indicators (fallback for images that failed to load)
      if (!hasImageInCache && post.imageUrls && post.imageUrls.length > 0) {
        pdf.setFontSize(8);
        pdf.setTextColor(100, 100, 100);
        pdf.text(`${post.imageUrls.length} image${post.imageUrls.length > 1 ? 's' : ''} attached`, margin + cardPadding, leftY + 3);
        leftY += lineHeight;
      }

      if (post.videoUrl) {
        pdf.setFontSize(8);
        pdf.setTextColor(100, 100, 100);
        pdf.text('Video attached', margin + cardPadding, leftY + 3);
        leftY += lineHeight;
      }

      // RIGHT COLUMN: Comments + Approval
      let rightY = cardTop + cardPadding;
      const rightX = margin + leftColumnWidth + cardPadding;

      // "Comments:" label
      pdf.setFontSize(8);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(60, 60, 60);
      pdf.text('Comments:', rightX, rightY + 3);
      rightY += 6;

      // Interactive comment field with white background and blue border
      pdf.setFillColor(255, 255, 255); // White background
      pdf.roundedRect(rightX, rightY, rightColumnWidth - 2 * cardPadding, commentFieldHeight, 3, 3, 'F');

      pdf.setDrawColor(33, 70, 236); // Brand blue border
      pdf.setLineWidth(0.5);
      pdf.roundedRect(rightX, rightY, rightColumnWidth - 2 * cardPadding, commentFieldHeight, 3, 3);

      const commentField = new (pdf as any).AcroFormTextField();
      commentField.fieldName = `comment_${globalPostIndex}`;
      commentField.Rect = [rightX + 1, rightY + 1, rightColumnWidth - 2 * cardPadding - 2, commentFieldHeight - 2];
      commentField.fontSize = 8;
      commentField.maxFontSize = 8;
      commentField.multiline = true;
      pdf.addField(commentField);

      rightY += commentFieldHeight + 3;

      // Approval checkboxes (larger, more visible)
      const checkboxSize = 5; // Increased from 4

      const approvedCheckbox = new (pdf as any).AcroFormCheckBox();
      approvedCheckbox.fieldName = `approved_${globalPostIndex}`;
      approvedCheckbox.Rect = [rightX, rightY, checkboxSize, checkboxSize];
      approvedCheckbox.value = 'Off';
      approvedCheckbox.appearanceState = 'Off';
      pdf.addField(approvedCheckbox);

      // Add visible border to checkbox
      pdf.setDrawColor(180, 180, 180);
      pdf.setLineWidth(0.3);
      pdf.roundedRect(rightX, rightY, checkboxSize, checkboxSize, 1.5, 1.5);

      pdf.setFontSize(9);
      pdf.setTextColor(34, 139, 34);
      pdf.text('✓ Approved', rightX + checkboxSize + 2, rightY + 4);

      rightY += checkboxSize + 2;

      const needsChangesCheckbox = new (pdf as any).AcroFormCheckBox();
      needsChangesCheckbox.fieldName = `needs_changes_${globalPostIndex}`;
      needsChangesCheckbox.Rect = [rightX, rightY, checkboxSize, checkboxSize];
      needsChangesCheckbox.value = 'Off';
      needsChangesCheckbox.appearanceState = 'Off';
      pdf.addField(needsChangesCheckbox);

      // Add visible border to checkbox
      pdf.setDrawColor(180, 180, 180);
      pdf.setLineWidth(0.3);
      pdf.roundedRect(rightX, rightY, checkboxSize, checkboxSize, 1.5, 1.5);

      pdf.setFontSize(9);
      pdf.setTextColor(180, 60, 60); // Reddish color for "Needs changes"
      pdf.text('✗ Needs changes', rightX + checkboxSize + 2, rightY + 4);

      // Move to next post
      yPosition = cardTop + cardHeight + postSpacing;

      globalPostIndex++;
    });

    // Add footer to month page
    addPDFFooter(pdf, PDF_FOOTER_POST_LIST, pageWidth, pageHeight, margin);
  }

  const blob = pdf.output('blob');

  // Convert blob to data URL for proper upload support
  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

  const filename = `content-calendar-${month}.pdf`;

  return {
    blob,
    dataUrl,
    filename
  };
}

export interface ExportCSVData {
  blob: Blob;
  dataUrl: string;
  filename: string;
  text: string;
}

export async function exportAsCSV(posts: CalendarPost[], month: string): Promise<ExportCSVData> {
  const csvData = posts.map(post => ({
    date: post.date,
    time: post.time,
    platform: post.platform,
    topic: post.topic,
    text: post.text,
    imageUrls: post.imageUrls ? post.imageUrls.join('|') : '',
    videoUrl: post.videoUrl || '',
    pageName: post.pageName || '',
    username: post.username || '',
  }));

  const csv = Papa.unparse(csvData, {
    quotes: true,
    header: true,
  });

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });

  // Convert blob to data URL for proper upload support
  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

  const filename = `content-calendar-${month}.csv`;

  return {
    blob,
    dataUrl,
    filename,
    text: csv
  };
}

export interface EmailApprovalData {
  mailtoUrl: string;
  subject: string;
  body: string;
}

export function generateEmailApprovalLink(month: string, postCount: number, platformCount: number): EmailApprovalData {
  const monthYear = new Date(month + '-01').toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
  });

  const subject = `Content Calendar Approval - ${monthYear}`;
  const body = `Hi,

Please review the attached content calendar for ${monthYear}.

${postCount} posts scheduled across ${platformCount} platforms.

For a better approval workflow with comments, notifications, and team collaboration, check out Kontentino: https://kontentino.com

Best regards`;

  const mailtoUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  return {
    mailtoUrl,
    subject,
    body
  };
}
